import React from 'react'

interface Props {}

export const TableBody: React.FC<Props> = ({ children }) => {
  return <tbody>{children}</tbody>
}
